import { useCallback, useEffect } from 'react';

import { useToast } from '@lotlinx-aws/sparky-component-library/Sparky/Toast';

import { ERROR_TOAST_EVENT } from 'store/errorToastEvent';

/**
 * Renders nothing — listens for ERROR_TOAST_EVENT dispatched by the global
 * query/mutation error handler and surfaces them as toasts.
 * Mount once inside <ToastProvider>.
 */
export default function ErrorToastListener() {
  const { addToast } = useToast();

  const handleEvent = useCallback(
    (e: Event) => {
      const error = (e as CustomEvent<Error>).detail;
      addToast({ status: 'error', description: error.message });
    },
    [addToast],
  );

  useEffect(() => {
    window.addEventListener(ERROR_TOAST_EVENT, handleEvent);
    return () => window.removeEventListener(ERROR_TOAST_EVENT, handleEvent);
  }, [handleEvent]);

  return null;
}
